import { useTranslation } from 'react-i18next'
import { Segmented } from '../v2/Segmented'

// Figma labels for the three database-backed formats; any other format keeps its manifest label.
const FORMAT_LABELS = {
  'medium-rectangle': 'M. Rectangle',
  'half-page': 'Halfpage',
  billboard: 'Billboard',
}

export function formatLabel(format) {
  return FORMAT_LABELS[format?.id] || format?.label || format?.id
}

/**
 * The "M. Rectangle / Halfpage / Billboard" switcher above the preview. It offers the
 * formats chosen in Campaign Setting (all of the template's formats by default) and changes
 * the ad's format through the regular editor update, which re-crops every slide image.
 */
export function FormatSwitcher({ manifest, offered, value, onChange, disabled }) {
  const { t } = useTranslation()
  const formats = (manifest?.formats || []).filter(
    (format) => !offered?.length || offered.includes(format.id) || format.id === value,
  )
  if (formats.length < 2) return null
  return (
    <Segmented
      ariaLabel={t('editorV2.shell.adFormat')}
      value={value}
      onChange={onChange}
      disabled={disabled}
      options={formats.map((format) => ({ value: format.id, label: formatLabel(format) }))}
    />
  )
}
